import { useEffect } from "react";

import { TiTick } from "react-icons/ti";
import Heading2 from "./common/HomePageHeadings";

function AboutUs() {
  // const video = `https://sv-static-assets.s3.ap-south-1.amazonaws.com/landing-page/videos/shaadi-vines-about-us.mp4`;
  const video = "/videos/shaadi-vines-about-us.mp4";

  const listData = [
    "Pre-Wedding Shoots",
    "Digital Invitations (Website)",
    "WEDcast - Live streaming",
    "Wedding Shoots",
    "Budget Planner",
  ];
  useEffect(() => {
    let options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.8,
    };

    let callback = (entries) => {
      entries.forEach((entry) => {
        if (entry.target.id == "myvideo") {
          if (entry.isIntersecting) {
            entry.target.play();
            // entry.target.muted = false;
          } else {
            entry.target.pause();
            // entry.target.muted = true;
          }
        }
      });
    };

    let observer = new IntersectionObserver(callback, options);
    const videos = document.querySelectorAll("video");

    videos.forEach((vide) => {
      observer.observe(vide);
    });
  }, []);

  return (
    <section
      id="about"
      className="bg-homeAbout bg-cover bg-no-repeat  w-full lg:py-20 py-0">
      <div className="grid grid-cols-12 lg:mx-28 mx-4 h-full">
        <div className="lg:col-span-6 md:col-span-6 col-span-12 lg:mt-0 mt-10 h-full flex flex-col justify-center">
          <Heading2 title="About Us" />

          <p className="lg:pl-10 pt-10 tracking-[2.5px] lg:text-lg text-sm text-center lg:text-left">
            At <b>Invitedekho</b>, we believe in the magic of every wedding
            journey. We start by capturing your precious moments with
            professional wedding photography, ensuring every emotion is
            beautifully preserved. These moments don't just stay as photos; we
            host them on our platform, making it convenient for you to share
            with loved ones near and far. Delving into the intricacies of
            planning, our intuitive budget planning tool assists in
            orchestrating your dream day down to the last detail. And to put the
            cherry on top, we help you craft unique digital invites, turning
            your memories into elegant invitations for your guests. Invitedekho:
            Where wedding memories are captured, shared, planned, and
            celebrated—all under one roof.
          </p>
          <ul className="lg:columns-2 md:columns-2 lg:ml-10 md:ml-10 my-10 flex flex-col items-center justify-center lg:block md:block">
            {listData.map((list, index) => {
              return (
                <li className="flex items-center pt-3" key={index}>
                  <TiTick className="text-lightGray mr-3" />
                  <p className=" tracking-[2.5px] text-lg">{list}</p>
                </li>
              );
            })}
          </ul>
        </div>
        <div className="lg:col-span-6 md:col-span-6 col-span-12 flex justify-center">
          <div className="flex  rounded-md lg:pb-0 py-10">
            <video
              autoPlay
              loop
              muted
              width="100%"
              preload="none"
              className="rounded-[10px] w-[350px] h-auto object-cover"
              style={{
                boxShadow: "-1px 6px 25px #f8dcee",
              }}>
              <source src={video} type="video/mp4" />
              Sorry, your browser doesn't support embedded videos.
              <track
                src="captions_en.vtt"
                kind="captions"
                srcLang="en"
                label="english_captions"
              />
              <meta itemProp="name" content="About Shaadi Vines" />
              <meta
                itemProp="description"
                content="
                Welcome to Shaadi Vines, where we blend the beauty of weddings with the power of technology. We are passionate about transforming the wedding experience for couples and their guests, creating unforgettable moments and simplifying the planning process."
              />
            </video>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutUs;
